import { RootState } from '../store'
export const selectProjets = (state: RootState) => state.projet.projets
export const selectLoading = (state: RootState) => state.projet.loading
export const selectError = (state: RootState) => state.projet.error
export const selectSCFCounts = (state: RootState) => state.projet.scfCounts
